<head>
    <style>
        .my-pagination /deep/ .ngx-pagination .current {
            font-family: "Graphik SemiBold";
            font-weight: normal;
            font-style: normal;
            font-display: swap;
            color: #265d6e;
            background: transparent;
        }
    </style>
</head>

<div class="container-fluid">
    <div *ngIf="successAlert" id="success-alert" class="alert alert-success alert-dismissible fade show mt-3" role="alert">
        <strong id="videoTitle"></strong> <span id="message">{{successAlertMessage}} </span>
        <button (click)="closeSuccessAlert()" type="button" class="close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div *ngIf="errorAlert" id="error-alert" class="alert alert-danger alert-dismissible fade show mt-3" role="alert">
        <span id="error-message">{{errorAlertMessage}}</span>
        <button (click)="closeErrorAlert()" type="button" class="close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <nav class="navbar navbar-light sub-nav">
        <a class="navbar-brand" [routerLink]="['/home']">
            <h5 class="Ws-subtitle">{{constants.ADMIN_NAV_ITEM_5}}</h5>
        </a>
    </nav>
    
    <!-- Loading State -->
    <div class="row mb-50" *ngIf="isLoading">
        <div class="col-md-4 col-sm-6 col-12" *ngFor="let item of skeltonArray">
            <div class="video-card">
                <img style="width: 100%;" [src]="item" alt="">
            </div>
        </div>
    </div>
    
    <!-- Empty State -->
    <div class="row mb-50" *ngIf="!isLoading && videos?.length === 0">
        <div class="col-12">
            <p class="error text-center">List is empty...</p>
        </div>
    </div>
    
    <!-- Video Cards - 3 per row -->
    <div class="row mb-50" *ngIf="!isLoading && videos?.length > 0">
        <div class="col-md-3 col-sm-6 col-12" 
             *ngFor="let video of videos | filter:videoTitle | paginate: { itemsPerPage: 10, currentPage: p }"
             id="{{video.videoName}}">
            <div class="video-card" id="{{video.videoName}}-row">
                    <img class="pending-video-icon mb-3" src="{{video.thumbnail || constants.BROKEN_IMG}}" alt="{{video.videoTitle}}"/>
                <div class="pending-video-title" id="pending-video-title">
                    <h6 id="{{video.videoName}}-title">{{video.videoTitle}}</h6>
                    <span style="font-size: 14px;" class="text-muted">{{video.uploadedOn}}</span>
                    <span class="approved-video-creator">{{video.creatorName}}</span>
                    <h6 class="mt-2">Failure Reason: {{video.vimeoStatus || video.vimeoMessage}}</h6>
                    <button (click)="retryVideo(video)" *ngIf="video.vimeoMessage" class="retry-btn"><span *ngIf='video.isRetrying' class="spinner-border spinner-border-sm mr-3" role="status"
                        aria-hidden="true"></span>{{constants.RETRY}}</button>
                    <button (click)="copyVideoName(video)" class="copy-btn">Copy VideoName</button>
                </div>
            </div>
        </div>
    </div>
    
    <!-- Pagination -->
    <div class="row footer">
        <!-- <div class="col-12"> -->
            <pagination-controls class="my-pagination" (pageChange)="p = $event"></pagination-controls>
        <!-- </div> -->
    </div>
</div>